module.exports = __webpack_public_path__ + "static/media/11NEPAD11.15f3cb2c.jpg";